<template>
  <v-form ref="form" v-model="valid" lazy-validation>
    <v-container>
      <h4>MerchantApp Welcome Ekranı Banner Detay</h4>

      <v-row style="margin-top: 50px;">
        <v-col cols="12" md="4">
          <h4>Başlık</h4>
          <v-text-field
            v-model="merchantOnBoardingData.title"
            maxlength="255"
            counter="255"
            :rules="titleRules"
            required
            name="input-7-1"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="8">
          <h4>Açıklama</h4>
          <v-textarea
            v-model="merchantOnBoardingData.description"
            maxlength="255"
            counter="255"
            rows="1"
            auto-grow
            :rules="descriptionRules"
            required
            name="input-7-1"
          ></v-textarea>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" md="4">
          <h4>
            Link
            <v-icon
              style="font-size: 17px;"
              v-if="!infoLink"
              color="#4d48f9"
              @click="infoLink = true"
            >
              info
            </v-icon>
          </h4>
          <v-alert
            v-model="infoLink"
            border="left"
            close-text="Close Alert"
            color="#4d48f9"
            dark
            dismissible
          >
            Dış Link eklerken http, https protokollerinin girilmesi gereklidir.
            <br />
            Örneğin: http://frink.com.tr, https://frink.com.tr
          </v-alert>
          <v-text-field
            v-model="merchantOnBoardingData.link"
            maxlength="255"
            counter="255"
          ></v-text-field>
        </v-col>

        <v-col cols="12" md="4">
          <h4>Link Metni</h4>
          <v-text-field
            v-model="merchantOnBoardingData.linkText"
            required
          ></v-text-field>
        </v-col>
      </v-row>
      <v-col cols="12" md="4">
        <h4>Sıralama</h4>
        <v-text-field
          v-model="merchantOnBoardingData.ordering"
          type="number"
          min="0"
          :rules="orderRules"
          required
        ></v-text-field>
      </v-col>

      <v-col cols="12" md="4">
        <h4>
          Görsel
          <v-icon
            style="font-size: 17px;"
            v-if="!infoImage"
            color="#4d48f9"
            @click="infoImage = true"
          >
            info
          </v-icon>
        </h4>
        <v-alert
          v-model="infoImage"
          border="left"
          close-text="Close Alert"
          color="#4d48f9"
          dark
          dismissible
        >
          Görsel boyutu: 654x400
          <br />
          Format: JPG
          <br />
          Dosya boyutu: Maximum 350 KB
        </v-alert>
        <v-img
          style="cursor: pointer;"
          v-if="
            (imgUrl !== '' && imgUrl !== undefined) ||
            (merchantOnBoardingData.img !== '' &&
              merchantOnBoardingData.img !== undefined)
          "
          :src="imgUrl ? imgUrl : merchantOnBoardingData.img"
          aspect-ratio="1.7"
        ></v-img>
        <v-file-input
          show-size
          v-model="merchantOnBoardingData.img"
          @change="previewFiles"
          accept="image/*"
          label="Resim değiştir"
          required
        ></v-file-input>
      </v-col>

      <v-col cols="12" md="4">
        <h4>Aktif/Pasif</h4>
        <v-checkbox
          v-model="merchantOnBoardingData.active"
          color="#4d48f9"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="8"></v-col>

      <v-col cols="12" md="7">
        <v-btn
          depressed
          color="#4d48f9"
          style="text-transform: none !important; float: right; color: white;"
          @click="merchantOnBoardingUpdate()"
        >
          GÜNCELLE
        </v-btn>
      </v-col>

      <v-dialog v-model="dialog" max-width="600">
        <v-card>
          <v-card-title class="headline">
            Lütfen alanları kontrol edin
          </v-card-title>

          <v-card-text>
            <ul>
              <li v-for="errorList in this.errorList" :key="errorList">
                {{ errorList }}
              </li>
            </ul>
          </v-card-text>
        </v-card>
      </v-dialog>
      <!-- <v-row>
            
        </v-row>-->
    </v-container>
  </v-form>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'MerchantOnBoardingDetails',
  computed: mapGetters(['merchantOnBoardingData']),
  methods: {
    ...mapActions(['getMerchantOnBoarding', 'putMerchantOnBoarding']),
    routeUsers() {
      this.$router.push('/dashboard/merchant-onboardings')
    },
    redirectImagePath(endpoint) {
      window.location.href = endpoint
    },
    merchantOnBoardingUpdate() {
      if (this.$refs.form.validate()) {
        this.snackbar = true
        this.putMerchantOnBoarding(this.merchantOnBoardingData)
          .then((response) => {
            if (response.processStatus) {
              this.$router.push('/dashboard/merchant-onboardings')
            }
          })
          .catch((err) => {
            const errors = err.response.data.errors
            if (errors && Object.keys(err.response.data.errors).length) {
              if (errors['Link']) {
                alert('Link alanını kontrol edin')
                return
              }
              if (errors['Ordering']) {
                if (errors['Ordering'] === 'ordering_cannot_be_same') {
                  alert('Sıralama değeri başka bir afiş ile aynı olamaz.')
                  return
                }
                if (errors['Ordering'] === 'cannot_be_negative') {
                  alert('Sıralama değeri negatif değer olamaz.')
                  return
                }
              }
            }
            alert(err)
          })
      } else {
        var errors = []
        var x = document.getElementsByClassName('v-messages__message')
        for (var i = 0; i < x.length; i++) errors.push(x[i].innerHTML)

        this.errorList = errors

        this.dialog = true
      }
    },
    previewFiles() {
      if (this.merchantOnBoardingData.img == undefined) {
        this.imgUrl = ''
      } else {
        const file = this.merchantOnBoardingData.img
        this.imgUrl = URL.createObjectURL(file)
      }
    },
  },
  data: () => ({
    titleValid: true,
    descriptionValid: true,
    alert: false,
    titleErrorMessage: '',
    descriptionErrorMessage: '',
    dialog: false,
    file: [],
    title: '',
    message: '',
    isVisible: false,
    managerName: '',
    valid: true,
    titleRules: [
      (v) => !!v || 'Başlık alanı zorunludur.',
      (v) => v.trim().length > 0 || 'Başlık alanı zorunludur.',
      (v) => v.length <= 255 || 'Maksimum 255 karakter olmalıdır.',
    ],
    // fileRules: [
    //   // value => value.size < 1000 || 'Avatar size should be less than 2 MB!',
    //   v => !!v || "Dosya gereklidir.",
    //   v => (v && v.name != null) || "Dosya gereklidir."
    // ],
    descriptionRules: [
      (v) => !!v || 'Açıklama alanı zorunludur.',
      (v) => v.trim().length > 0 || 'Açıklama alanı zorunludur.',
      (v) => v.length <= 255 || 'Maksimum 255 karakter olmalıdır.',
    ],
    // linkRules: [v => !!v || "Link alanı zorunludur."],
    orderRules: [
      //   v => !!v || "Sıralama alanı zorunludur.",
      (v) => parseFloat(v) > -1 || "Sıralama 0'dan küçük olmamalıdır.",
    ],
    errorList: [],
    infoImage: false,
    infoLink: false,
    imgUrl: '',
  }),
  created() {
    let id = this.$route.params.id
    this.getMerchantOnBoarding(id).then((data) => {
      this.imgUrl = data.imgUrl
    })
  },
}
</script>
